import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bp9ko7sqyj: FaireBrandEntity = {
  token: "b_bp9ko7sqyj",
  type: "brand",
  name: "Angle",
  avatarUrl:
    "https://cdn.faire.com/fastly/ac295d9dc4b04606d44fa8e8fd677af4ff0115fbb918a9ea02f7a72a0eb87439.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1e6d5f0713f21cf13e9d6acdef043ed3d262792260a4b95a367ec8ed4c9749e8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ac295d9dc4b04606d44fa8e8fd677af4ff0115fbb918a9ea02f7a72a0eb87439.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1e6d5f0713f21cf13e9d6acdef043ed3d262792260a4b95a367ec8ed4c9749e8.jpeg",
  location: "Phoenix, AZ, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 190,
  isInsider: true,
  description:
    "Don’t miss out on unbeatable prices on our best-selling products! As the overstock storefront for CBC Group, we proudly feature brands like Santa Barbara Design Studio, 47th & Main, Slant, Stephan Baby, Faithworks, Bella Sleep & Spa, and Pomchies Urban Essentials.\n\n🔥 Hurry! Hot items fly off the shelves, so shop now and check back frequently for fresh finds! Your next great buy is just a click away!\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:25.723Z",
    importedBy: "entity-db-cli",
  },
};
